// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.wrapper .map_section {
  width: 75%;
  height: 100%;
  transition: ease-in-out 1s;
  position: relative;
}
@media (max-width: 992px) {
  .wrapper .map_section {
    width: 100%;
  }
}
.wrapper .map_section.hide_section {
  width: 0%;
}
.wrapper .sidebar_section {
  width: 35%;
  max-width: 700px;
  background-size: cover;
  transition: width 1.5s flex-direction 2s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  transition: ease-in-out 1s;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section {
    width: 0;
  }
  .wrapper .sidebar_section app-venue-suggestion {
    visibility: none;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
}
@media (min-width: 991px) {
  .wrapper .sidebar_section {
    border-left: 1px solid #272727;
    background: #000;
    padding: 0 1.6%;
  }
}
.wrapper .sidebar_section.full-width {
  padding: 100px 50px;
  transition: all 1s;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}
.wrapper .sidebar_section.full-width .title {
  display: none;
  visibility: none;
  opacity: 0;
  transition: visibility 2s;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width {
    flex-direction: column !important;
    width: 100% !important;
    padding: 100px 20px;
    flex-wrap: nowrap;
  }
}
.wrapper .sidebar_section.full-width app-venue-suggestion {
  width: 24%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width app-venue-suggestion {
    width: 100%;
    opacity: 1;
  }
}

#map {
  width: 100%;
  height: 100%;
}
@media (min-width: 991px) {
  #map {
    height: 100%;
  }
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
  width: 100%;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 15px;
}

#search-container {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.search-container-input {
  top: 30px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}

.slides-container {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  --background: red;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 100%;
}
@media (max-width: 992px) {
  app-venue-suggestion {
    width: 94%;
  }
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
}

.mode-icon {
  padding: 10px;
  height: 25px;
  width: 25px;
}

.mode-icon {
  background: #f8f8f8;
  fill: var(--ion-color-primary);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  fill: #f8f8f8;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}
.loading-container ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  color: white;
}
@media (min-width: 991px) {
  .loading-container ion-spinner {
    width: 80px;
    height: 80px;
  }
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-venues {
  background: #f8f8f8;
}

.full-height {
  height: 100%;
}

#show_toggler,
#search-container-input {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
  padding: 10px;
  transition: top 1s;
  z-index: 10;
}
@media (max-width: 992px) {
  #show_toggler,
  #search-container-input {
    width: 350px;
    top: 30px;
  }
}
#show_toggler h3,
#search-container-input h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
}
#show_toggler.move_up,
#search-container-input.move_up {
  top: 10px;
}

.swiper-wrapper {
  width: 100%;
  margin-bottom: 20px;
}
.swiper-wrapper swiper-slide {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.swiper-wrapper swiper-slide.swiper-slide-next {
  opacity: 1;
}
.swiper-wrapper swiper-slide.swiper-slide-active {
  opacity: 1;
}

swiper-container {
  --background: transparent;
}

swiper-slide {
  display: flex;
  justify-content: center;
  height: auto !important;
}

app-map-search-venue {
  width: 100%;
}

#show_toggler h3 {
  text-transform: uppercase;
  font-size: 16px;
}

.scroll-block {
  max-height: calc(100vh - 95px);
  --background: transparent;
  background: transparent;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scroll-block::part(scroll)::-webkit-scrollbar {
  display: none;
}

.scroll-block::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.enter_address {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  display: flex;
  flex-direction: column;
}
.enter_address.hide-item {
  opacity: 0;
}
@media (max-width: 992px) {
  .enter_address {
    top: 120px;
  }
}
.enter_address .wrapper_input {
  background: white;
  border-radius: 16px;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  width: 100%;
}
.enter_address ion-input {
  font-size: 18px;
  color: var(--ion-color-secondary);
  font-family: AppFontMedium, sans-serif;
}
.enter_address ion-icon {
  width: 30px;
  height: 30px;
}
.enter_address .pac-container {
  background: white;
  width: 100%;
  padding: 8px 20px !important;
  margin-top: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
  border: none !important;
}
.enter_address .pac-container .pac-item {
  border-top: none !important;
  font-family: Subway, sans-serif;
  padding: 16px 0;
  line-height: 1 !important;
  font-size: 14px !important;
  border-bottom: 0.5px solid #e8e8e8;
}
.enter_address .pac-container .pac-item:last-child {
  border-bottom: none;
}
.enter_address .pac-container .pac-item .pac-matched {
  font-family: Subway-bold, sans-serif;
}

.wrapper_for_types {
  height: 45px;
  width: 90%;
  background: #f6f1ef;
  border-radius: var(--border-radius-default);
  padding: 10px 0px;
  margin: 0 auto 27px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
@media (min-width: 991px) {
  .wrapper_for_types.wrapper_for_types_desktop {
    display: none;
  }
}
.wrapper_for_types .item {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: color 1s ease-in-out;
}
.wrapper_for_types .item p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 20.2px;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-black-alt);
  position: relative;
  z-index: 1;
}
.wrapper_for_types .item.active p, .wrapper_for_types .item.active span {
  color: var(--color-white);
}
.wrapper_for_types .selector {
  position: absolute;
  left: 3%;
  top: 50%;
  width: 49%;
  height: 96%;
  transform: translate(-5%, -50%);
  border-radius: var(--border-radius-default);
  background: var(--ion-color-primary);
  transition: left 0.5s ease-in-out;
}
.wrapper_for_types .selector.second-position {
  left: 55%;
}
.wrapper_for_types .min-value {
  font-size: 8px;
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.types-title {
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 2px;
  border-bottom: 1px solid #222222;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 27px;
  letter-spacing: 0.08em;
  text-align: center;
}

.show-error {
  opacity: 0.5;
}

.address-delivery {
  position: absolute;
  z-index: 99;
  background: var(--accent-color);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 18px;
  width: 350px;
  top: calc(2vh + 52px);
  left: 50%;
  translate: -50%;
  line-height: 19px;
}
.address-delivery .address {
  font-family: AppFontMedium, sans-serif;
  font-size: 14px;
  color: #fff;
}
.address-delivery .clear-map-address-btn {
  cursor: pointer;
  font-size: 14px;
  color: var(--color-white);
}
.address-delivery .clear-map-address-btn:hover {
  color: #fff;
}

.input-highlight {
  display: none;
}

.padding-block {
  width: 70%;
}

ion-input {
  position: absolute;
  top: 2vh;
  background: #353535;
  max-width: 400px;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  --padding-start: 16px;
  --padding-end: 16px;
  border-radius: 10px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/map/components/map-venue/map-venue.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;AADD;AAEC;EACC,UAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;AAAF;ACHE;EDDD;IAME,WAAA;EAED;AACF;AADE;EACC,SAAA;AAGH;AAAC;EAeC,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAbF;ACxBE;EDWD;IAEE,QAAA;EAeD;EAdC;IACC,gBAAA;IACA,UAAA;IACA,kCAAA;EAgBF;AACF;ACxCE;EDiBD;IAWE,8BAAA;IACA,gBAAA;IACM,eAAA;EAgBP;AACF;AAFE;EAOC,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAFH;AAXG;EACC,aAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AAaJ;ACzDE;EDuCA;IAgBE,iCAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EAMF;AACF;AALG;EACC,UAAA;AAOJ;ACpEE;ED4DC;IAGE,WAAA;IAEA,UAAA;EAQH;AACF;;AAFA;EACC,WAAA;EAEA,YAAA;AAID;ACrFE;ED8EF;IAKE,YAAA;EAMA;AACF;;AAHA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AAMD;;AAHA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAMD;;AAJA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAOD;;AALA;EACC,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAQD;AANC;EACC,WAAA;AAQF;;AALA;EACC,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAQD;;AANA;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EAEA,iBAAA;AAQD;;AALA;EACC,oBAAA;AAQD;;AALA;EACC,WAAA;AAQD;AChJE;EDuIF;IAGE,UAAA;EAUA;AACF;;AARA;EACC,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AAWD;;AATA;EACC,YAAA;AAYD;;AATA;EACC,aAAA;EACA,YAAA;EACA,WAAA;AAYD;;AATA;EACC,mBAAA;EACA,8BAAA;EACA,uBAAA;AAYD;;AATA;EACC,oCAAA;EACA,aAAA;EACA,uBAAA;AAYD;;AATA;EACC,YAAA;AAYD;;AATA;EAKC,cAAA;EACA,YAAA;AAQD;AAbC;EACC,gBAAA;AAeF;AATC;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AAWF;;AARA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAWD;AAVC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAYF;AC7NE;ED0MD;IASE,WAAA;IACA,YAAA;EAcD;AACF;;AAVA;EACC,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAaD;AAXC;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAaF;AAVC;EACC,eAAA;AAYF;AATC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAWF;;AAPA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAUD;;AAPA;EACC,mBAAA;AAUD;;AARA;EACC,YAAA;AAWD;;AATA;;EAEC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wDAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAYD;ACjRE;EDuPF;;IAgBE,YAAA;IACA,SAAA;EAeA;AACF;AAdC;;EACC,oCAAA;EACA,eAAA;AAiBF;AAfC;;EACC,SAAA;AAkBF;;AAfA;EACC,WAAA;EACA,mBAAA;AAkBD;AAjBC;EACC,UAAA;EACA,oCAAA;AAmBF;AAlBE;EACC,UAAA;AAoBH;AAlBC;EACC,UAAA;AAoBF;;AAfA;EACC,yBAAA;AAkBD;;AAhBA;EACC,aAAA;EACA,uBAAA;EACA,uBAAA;AAmBD;;AAhBA;EACC,WAAA;AAmBD;;AAhBC;EACC,yBAAA;EACA,eAAA;AAmBF;;AAhBA;EACC,8BAAA;EACA,yBAAA;EACA,uBAAA;AAmBD;;AATA,gDAAA;AACA;EACE,aAAA;AAYF;;AAVA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAaF;;AAXA;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AAcD;AAbC;EACC,UAAA;AAeF;AChWE;EDwUF;IAYE,UAAA;EAgBA;AACF;AAfC;EACC,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;AAiBF;AAfC;EACC,eAAA;EACA,iCAAA;EACA,sCAAA;AAiBF;AAfC;EACC,WAAA;EACA,YAAA;AAiBF;AAfC;EACC,iBAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,oDAAA;EACA,6BAAA;EACA,uBAAA;AAiBF;AAfE;EACC,2BAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,kCAAA;AAiBH;AAfG;EACC,mBAAA;AAiBJ;AAdG;EACC,oCAAA;AAgBJ;;AAXA;EAEC,YAAA;EACA,UAAA;EACA,mBAAA;EACA,2CAAA;EACA,iBAAA;EACA,mBAAA;EAEA,aAAA;EACA,8BAAA;EACA,kBAAA;AAYD;AClaE;EDwZD;IAEE,aAAA;EAYD;AACF;AATC;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AAWF;AAVE;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAYH;AATG;EACC,yBAAA;AAWJ;AANC;EACC,kBAAA;EACA,QAAA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EAEF,+BAAA;EACA,2CAAA;EACA,oCAAA;EACA,iCAAA;AAOF;AALE;EACC,SAAA;AAOH;AAJC;EACC,cAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAMF;;AAFA;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;EACD,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAKD;;AAHA;EACC,YAAA;AAMD;;AAHA;EACC,kBAAA;EACG,WAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACH,YAAA;EACA,qBAAA;EACG,SAAA;EACA,eAAA;EACH,iBAAA;AAMD;AALC;EACC,sCAAA;EACA,eAAA;EACA,WAAA;AAOF;AALC;EACC,eAAA;EACA,eAAA;EACA,yBAAA;AAOF;AANE;EACC,WAAA;AAQH;;AAFA;EACC,aAAA;AAKD;;AAHA;EACC,UAAA;AAMD;;AAAA;EACC,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAGD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\t.map_section {\n\t\twidth: 75%;\n\t\theight: 100%;\n\t\ttransition: ease-in-out 1s;\n\t\tposition: relative;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t\t&.hide_section {\n\t\t\twidth: 0%;\n\t\t}\n\t}\n\t.sidebar_section {\n\t\t@include mobile {\n\t\t\twidth: 0;\n\t\t\tapp-venue-suggestion {\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: opacity 1s ease-in-out;\n\t\t\t}\n\t\t}\n\n\t\t@include desktop {\n\t\t\tborder-left: 1px solid #272727;\n\t\t\tbackground:  #000;\n      \t\t\tpadding: 0 1.6%;\n\t\t}\n\t\twidth: 35%;\n\t\tmax-width: 700px;\n\t\tbackground-size: cover;\n\t\ttransition: width 1.5s flex-direction 2s;\n\t\toverflow: auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\ttransition: ease-in-out 1s;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\theight: 100%;\n\n\t\t&.full-width {\n\t\t\t.title {\n\t\t\t\tdisplay: none;\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: visibility 2s;\n\t\t\t}\n\t\t\tpadding: 100px 50px;\n\t\t\ttransition: all 1s;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: row;\n\t\t\t@include mobile {\n\t\t\t\tflex-direction: column !important;\n\t\t\t\twidth: 100% !important;\n\t\t\t\tpadding: 100px 20px;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t\tapp-venue-suggestion {\n\t\t\t\twidth: 24%;\n\t\t\t\t@include mobile {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n#map {\n\twidth: 100%;\n\t// height: calc(100% - 115px);\n\theight: 100%;\n\t@include desktop {\n\t\theight: 100%;\n\t}\n}\n\n.search-bar {\n\tborder-radius: 4px;\n\tline-height: 1.6;\n\twidth: 100%;\n}\n\n.search-bar > div {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tplace-items: center;\n}\n.title {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tmargin-left: 15px;\n\tmargin-top: 15px;\n}\n#search-container {\n\ttop: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n\n\tapp-venue-suggestion {\n\t\twidth: 100%;\n\t}\n}\n.search-container-input {\n\ttop: 30px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n}\n.slides-container {\n\tposition: absolute;\n\tbottom: 0px;\n\tleft: 0;\n\tright: 0;\n\twidth: 100%;\n\tdisplay: flex;\n\n\t--background: red;\n}\n\n.swiper-slide {\n\talign-self: flex-end;\n}\n\napp-venue-suggestion {\n\twidth: 100%;\n\t@include mobile {\n\t\twidth: 94%;\n\t}\n}\n.map-toggle {\n\tdisplay: flex;\n\tjustify-content: space-between !important;\n\talign-items: center;\n\tpadding: 5px;\n}\n.map-toggle-container {\n\theight: 48px;\n}\n\n.mode-icon {\n\tpadding: 10px;\n\theight: 25px;\n\twidth: 25px;\n}\n\n.mode-icon {\n\tbackground: #f8f8f8;\n\tfill: var(--ion-color-primary);\n\ttransition: 0.3s linear;\n}\n\n.mode-icon.selected {\n\tbackground: var(--ion-color-primary);\n\tfill: #f8f8f8;\n\ttransition: 0.3s linear;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.sidebar {\n\tapp-venue-suggestion {\n\t\tmargin: 5px auto;\n\t}\n\n\toverflow: auto;\n\theight: 100%;\n\n\t.title {\n\t\twidth: 90%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n}\n.loading-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\tbackground: black;\n\topacity: 0.5;\n\tion-spinner {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 70px;\n\t\theight: 70px;\n\t\tcolor: white;\n\t\t@include desktop {\n\t\t\twidth: 80px;\n\t\t\theight: 80px;\n\t\t}\n\t}\n}\n\n.hint {\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tpadding: 14px;\n\tbackground: white;\n\n\tp {\n\t\tfont-size: 12px;\n\t\tcolor: black;\n\t\tmargin: 0;\n\t\tpadding: 0 8px;\n\t}\n\n\tspan {\n\t\tfont-size: 14px;\n\t}\n\n\tion-icon {\n\t\theight: 44px;\n\t\twidth: 44px;\n\t\tplace-self: center;\n\t}\n}\n\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.block-venues {\n\tbackground: #f8f8f8;\n}\n.full-height {\n\theight: 100%;\n}\n#show_toggler,\n#search-container-input {\n\tposition: absolute;\n\ttop: 50px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 450px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbox-shadow: 0px 0px 50px 0px #0000001a;\n\tbackground: white;\n\tpadding: 10px;\n\ttransition: top 1s;\n\tz-index: 10;\n\t@include mobile {\n\t\twidth: 350px;\n\t\ttop: 30px;\n\t}\n\th3 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 20px;\n\t}\n\t&.move_up {\n\t\ttop: 10px;\n\t}\n}\n.swiper-wrapper {\n\twidth: 100%;\n\tmargin-bottom: 20px;\n\tswiper-slide {\n\t\topacity: 0;\n\t\ttransition: opacity 0.3s ease-in-out;\n\t\t&.swiper-slide-next {\n\t\t\topacity: 1;\n\t\t}\n\t&.swiper-slide-active {\n\t\topacity: 1;\n\t}\n\t}\n\n}\nswiper-container {\n\t--background: transparent;\n}\nswiper-slide {\n\tdisplay: flex;\n\tjustify-content: center;\n\theight: auto !important;\n\t// margin-top: auto;\n}\napp-map-search-venue {\n\twidth: 100%;\n}\n#show_toggler {\n\th3 {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 16px;\n\t}\n}\n.scroll-block {\n\tmax-height: calc(100vh - 95px);\n\t--background: transparent;\n\tbackground: transparent;\n\t// --padding-start: 20px;\n\t// --padding-end: 20px;\n\t// app-venue-suggestion {\n\t//   width: 100% !important;\n\t// }\n\n  \n  \n}\n/* Hide scrollbar for Chrome, Safari and Opera */\n.scroll-block::part(scroll)::-webkit-scrollbar {\n  display: none;\n}\n.scroll-block::part(scroll) {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n.enter_address {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 80%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t&.hide-item {\n\t\topacity: 0;\n\t}\n\t@include mobile {\n\t\ttop: 120px;\n\t}\n\t.wrapper_input {\n\t\tbackground: white;\n\t\tborder-radius: 16px;\n\t\tz-index: 99;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 5px 10px;\n\t\twidth: 100%;\n\t}\n\tion-input {\n\t\tfont-size: 18px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\t.pac-container {\n\t\tbackground: white;\n\t\twidth: 100%;\n\t\tpadding: 8px 20px !important;\n\t\tmargin-top: 5px;\n\t\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;\n\t\tborder-radius: 4px !important;\n\t\tborder: none !important;\n\n\t\t.pac-item {\n\t\t\tborder-top: none !important;\n\t\t\tfont-family: Subway, sans-serif;\n\t\t\tpadding: 16px 0;\n\t\t\tline-height: 1 !important;\n\t\t\tfont-size: 14px !important;\n\t\t\tborder-bottom: 0.5px solid #e8e8e8;\n\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\n\t\t\t.pac-matched {\n\t\t\t\tfont-family: Subway-bold, sans-serif;\n\t\t\t}\n\t\t}\n\t}\n}\n.wrapper_for_types {\n\n\theight: 45px;\n\twidth: 90%;\n\tbackground: #f6f1ef;\n\tborder-radius: var(--border-radius-default);\n\tpadding: 10px 0px;\n\tmargin: 0 auto 27px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tposition: relative;\n\n\t&.wrapper_for_types_desktop {\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.item {\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: color 1s ease-in-out;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 20.2px;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-black-alt);\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t}\n\t\t&.active {\n\t\t\tp, span {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n\n\t.selector {\n\t\tposition: absolute;\n\t\tleft: 3%;\n    top: 50%;\n    width: 49%;\n    height: 96%;\n\n\t\ttransform: translate(-5%, -50%);\n\t\tborder-radius: var(--border-radius-default);\n\t\tbackground: var(--ion-color-primary);\n\t\ttransition: left 0.5s ease-in-out;\n\n\t\t&.second-position {\n\t\t\tleft: 55%;\n\t\t}\n\t}\n\t.min-value {\n\t\tfont-size: 8px;\n\t\tposition: absolute;\n\t\tbottom: -13px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\twidth: 100%;\n\t}\n}\n\n.types-title {\n  width: 100%;\n  padding-bottom: 10px;\n  margin-bottom: 2px;\n  border-bottom: 1px solid #222222;\n\tfont-family: AppFontMedium;\n\tfont-size: 12px;\n\tline-height: 27px;\n\tletter-spacing: 0.08em;\n\ttext-align: center;\n}\n.show-error {\n\topacity: 0.5;\n}\n\n.address-delivery{\n\tposition: absolute;\n    z-index: 99;\n    background: var(--accent-color);\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 18px;\n\twidth: 350px;\n\ttop: calc(2vh + 52px);\n    left: 50%;\n    translate: -50%;\n\tline-height: 19px;\n\t.address {\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 14px;\n\t\tcolor: #fff;\n\t}\n\t.clear-map-address-btn {\n\t\tcursor: pointer;\n\t\tfont-size: 14px;\n\t\tcolor: var(--color-white);\n\t\t&:hover {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\t\n}\n\n.input-highlight {\n\tdisplay: none;\n}\n.padding-block {\n\twidth: 70%;\n}\n\n\n\n\nion-input {\n\tposition: absolute;\n\ttop: 2vh;\n\tbackground: #353535;\n\tmax-width: 400px;\n\twidth: 90%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t--padding-start: 16px;\n\t--padding-end: 16px;\n\tborder-radius: 10px;\n\tcolor: white;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
